module.exports = __webpack_public_path__ + "static/media/logo.b7bbaf61.svg";